(function ($) {
    class Form {

        // Init all functions
        static initAll(context) {
            context.querySelectorAll('.form').forEach(form => {
                if (form.classList.contains(('attached'))) {
                    return;
                }
                form.classList.add('attached');
                Form.initSelect(form);
                Form.initDatePicker(form);
            });
        }

        // Init all functions
        static initAfterRender(context) {
            Form.initSelect(context);
            Form.initDatePicker(context);
        }

        static initSelect(context) {
            $('select', context).each(function () {

                const select = $(this);

                const label = select.closest('.gfield').find('label').text();

                if (!select.parent().attr('id')) {
                    var id = 'select-' + new Date().valueOf();
                    select.parent().attr('id', id);
                }

                if (select.find('option').first().val() != '') {
                    select.prepend('<option></option>');
                }

                select.select2({
                    minimumResultsForSearch: 100,
                    dropdownParent: $(this).parent(),
                    placeholder: label
                });
            });
        }


        static formElementStates(context) {
            context.querySelectorAll('input, textarea, select').forEach((element) => {
                $(element).on('change blur keydown keyup', function () {
                    Form.checkInput(element);
                });

                Form.checkInput(element);
            });
        }

        static checkInput(input) {
            const $input = $(input);
            const $field = $input.parents('.gfield');

            // Skip hidden fields
            if ($input.attr('type') === 'hidden') {
                return false;
            }

            if ($input.val() != '') {
                $field.addClass('gfield--filled');
            } else {
                $field.removeClass('gfield--filled');
            }
        }


        static formPlaceholders(context) {
            $('.gfield', context).each(function () {
                var input = $(this).find('input:not([type=radio]):not([type=checkbox]), textarea, select');
                if (input.length) {
                    var label = $(this).find('label').first();
                    input.attr('placeholder', label.text());
                    label.addClass('label--floatLabel').wrapInner('<span></span>');
                }
            });
        }

        static initDatePicker(context) {
            if (typeof jQuery.datepicker != 'undefined') {
                $('input.datepicker', context).datepicker('option', {
                    minDate: +1,
                    // maxDate: +30,
                    // firstDay: 1,
                    changeMonth: false,
                    changeYear: false,
                    // beforeShowDay: function (date) {
                    //     var day = date.getDay();
                    //     if (day === 2 || day === 4) {
                    //         return [true];
                    //     }
                    //     return [false];
                    // },
                    clearText: 'Wissen', clearStatus: '',
                    closeText: 'sluiten', closeStatus: 'Onveranderd sluiten ',
                    prevText: '<vorige', prevStatus: 'Zie de vorige maand',
                    nextText: 'volgende>', nextStatus: 'Zie de volgende maand',
                    currentText: 'Huidige', currentStatus: 'Bekijk de huidige maand',
                    monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
                    monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
                    monthStatus: 'Bekijk een andere maand', yearStatus: 'Bekijk nog een jaar',
                    weekHeader: 'Sm', weekStatus: '',
                    dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
                    dayNamesShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
                    dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
                    dayStatus: 'Gebruik DD als de eerste dag van de week', dateStatus: 'Kies DD, MM d',
                    initStatus: 'Kies een datum', isRTL: false
                }).attr('readonly', 'readonly');
            }
        }
    }


    /**
     * Form behaviour
     */
    VIV.behaviours.form = {
        attach: function (context) {
            Form.initAll(context);
        },
        initSelect: function (context) {
            Form.initSelect(context);
        }
    };

    $(document).on('gform_post_render', (e) => {
        Form.initAfterRender(e.target);
    });

})(jQuery);
